import {
    ADDORUPDATEMODULEMASTERFORADMIN_SUCCESS,
    ADDORUPDATEMODULEMASTERFORADMIN_FAILED,
    RESET_ADDORUPDATEMODULEMASTERFORADMIN,
    LOADING_ADDORUPDATEMODULEMASTERFORADMIN,
    NETWORK_ERROR_ADDORUPDATEMODULEMASTERFORADMIN,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADDORUPDATEMODULEMASTERFORADMIN:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case ADDORUPDATEMODULEMASTERFORADMIN_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case ADDORUPDATEMODULEMASTERFORADMIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_ADDORUPDATEMODULEMASTERFORADMIN:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_ADDORUPDATEMODULEMASTERFORADMIN:
            return (state = initialState);
        default:
            return state;
    }
};
